export default {
  users: [],
  roles: []
}



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js